import { RestRequest } from "@Utils";
import { ITextMessage } from "atlas-shared";

export const sendTextMessage = (id: string, payload: ITextMessage): Promise<ITextMessage> => {
  return RestRequest.post<ITextMessage, ITextMessage>(
    `api/v1/text_message_source/${id}/text_message`,
    payload
  );
};

export const getTextMessages = (sourceId: string): Promise<ITextMessage[]> => {
  return RestRequest.get<ITextMessage[]>(`api/v1/text_message_source/${sourceId}/text_message`);
};
